// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"57ec6af1","383":"182445f4","787":"09d0c4e0"}[chunkId] + ".chunk.js";
};